import { IShop } from "interfaces";
import cls from "./shopCard.module.scss";
import Link from "next/link";
import ShopLogo from "components/shopLogo/shopLogo";
import getImage from "utils/getImage";
import ShopBadges from "containers/shopBadges/shopBadges";
import FallbackImage from "components/fallbackImage/fallbackImage";
import useLocale from "hooks/useLocale";
import useShopWorkingSchedule from "hooks/useShopWorkingSchedule";
import VerifiedComponent from "components/verifiedComponent/verifiedComponent";
import { Rating } from "@mui/material";

type Props = {
  data: IShop;
};

export default function ShopCard({ data }: Props) {
  const { t } = useLocale();
  const { isShopClosed, workingSchedule } = useShopWorkingSchedule(data);
  return (
    <Link href={`/shop/${data.id}`} className={`${cls.wrapper}`}>
      <div className={cls.header}>
        <FallbackImage
          fill
          src={getImage(data.background_img)}
          alt={data.translation?.title}
          sizes="400px"
          quality={90}
        />
      </div>
      <div className={cls.shopLogo}>
        <ShopLogo data={data} />
      </div>
      <div className={cls.body}>
        <ShopBadges data={data} />
        <div className={cls.titleContainer}>
          <h3 className={`${cls.title} ${!data?.verify && cls.maxWidth}`}>
            {data.translation?.title}
          </h3>
          {!!data?.verify && <VerifiedComponent />}
        </div>
        <p className={cls.text}>
          {!isShopClosed ? (
            <span>
              {workingSchedule?.from} - {workingSchedule?.to}
            </span>
          ) : (
            <span>{t("closed")}</span>
          )}
        </p>
        <div className={cls.rating}>
          <Rating
            value={data?.r_avg || 0}
            readOnly
            size="small"
            precision={0.5}
            name="ratingIcon"
            color="var(--orange)"
            className={cls.ratingIcon}
          />
          <p className={cls.ratingCount}>{data?.r_count || 0}</p>
        </div>
      </div>
    </Link>
  );
}
